import { render, staticRenderFns } from "./select-dropdown.vue?vue&type=template&id=36728d3b&scoped=true&"
import script from "./select-dropdown.vue?vue&type=script&lang=js&"
export * from "./select-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./select-dropdown.vue?vue&type=style&index=0&id=36728d3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36728d3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/gitlab-runner/builds/UejMkTXs/0/feng.chen/site-cms/site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36728d3b')) {
      api.createRecord('36728d3b', component.options)
    } else {
      api.reload('36728d3b', component.options)
    }
    module.hot.accept("./select-dropdown.vue?vue&type=template&id=36728d3b&scoped=true&", function () {
      api.rerender('36728d3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/select/select-dropdown.vue"
export default component.exports